exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading{position:fixed;top:0;right:0;bottom:0;left:0;background:#fff\n}\n.loader{left:50%;margin-left:-4em;font-size:10px;border:.8em solid #dadbdf;border-left:.8em solid #3aa6a5;-webkit-animation:spin 1.1s infinite linear;animation:spin 1.1s infinite linear\n}\n.loader,.loader:after{border-radius:50%;width:8em;height:8em;display:block;position:absolute;top:50%;margin-top:-4.05em\n}\n@-webkit-keyframes spin{\n0%{transform:rotate(360deg)\n}\n100%{transform:rotate(0deg)\n}\n}\n@keyframes spin{\n0%{transform:rotate(360deg)\n}\n100%{transform:rotate(0deg)\n}\n}", ""]);

// exports
